import React from 'react';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';

const MODAL_TITLE_ID = 'user-activity-confirmation-modal-title';

export interface ConfirmationModalProps {
  isOpen: boolean;
  onClose(): void;
  title?: string | null;
  message?: string | null;
  footer?: React.ReactNode;
}

export const ConfirmationModal = ({
  isOpen,
  onClose,
  title,
  message,
  footer,
}: ConfirmationModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      size="medium"
      aria={title ? { labelledby: MODAL_TITLE_ID } : undefined}
    >
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <Box display="flex" flexDirection="column" gridGap="16" pt="16">
          {title && (
            <Text id={MODAL_TITLE_ID} fontSize="h4" fontWeight={600} color="neutral.700">
              {title}
            </Text>
          )}

          {message && (
            <Text fontSize="body" lineHeight="24px" color="neutral.600">
              {message}
            </Text>
          )}
        </Box>
      </ModalBody>

      {footer != null && (
        <ModalFooter hasBorder>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="flex-end"
            gridGap="8"
            width="100%"
          >
            {footer}
          </Box>
        </ModalFooter>
      )}
    </Modal>
  );
};
